import { render, staticRenderFns } from "./RequerimientoPhone.vue?vue&type=template&id=68cc2308&"
import script from "./RequerimientoPhone.vue?vue&type=script&lang=js&"
export * from "./RequerimientoPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VTextarea,
})
